if (!String.prototype.toLowerCaseFirst) {
  // eslint-disable-next-line
  console.log('Добавляем полифил String.prototype.toLowerCaseFirst()')
  // Дадим строке метод для снижения регистра первой буквы toLowerCaseFirst().
  /* eslint-disable-next-line no-extend-native */
  String.prototype.toLowerCaseFirst = function () {
    return this.substring(0, 1).toLocaleLowerCase() + this.substring(1)
  }
}

if (!String.prototype.toUpperCaseFirst) {
  // eslint-disable-next-line
  console.log('Добавляем полифил String.prototype.toUpperCaseFirst()')
  // Дадим строке метод для повышения регистра первой буквы toUpperCaseFirst().
  /* eslint-disable-next-line no-extend-native */
  String.prototype.toUpperCaseFirst = function () {
    return this.substring(0, 1).toLocaleUpperCase() + this.substring(1)
  }
}
